import script from "./CostOfSales.vue?vue&type=script&setup=true&lang=js"
export * from "./CostOfSales.vue?vue&type=script&setup=true&lang=js"

import "./CostOfSales.vue?vue&type=style&index=0&id=3f39d98b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f39d98b"]])

export default __exports__